import React from 'react';

const WorkerHatIcon = ({
  width = '18',
  height = '18',
  fill = 'none',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill={fill}
    {...props}
  >
    <g opacity="0.5">
      <path
        d="M10.875 12V3.75C10.875 3.35218 10.717 2.97064 10.4357 2.68934C10.1544 2.40804 9.77282 2.25 9.375 2.25H8.625C8.22718 2.25 7.84564 2.40804 7.56434 2.68934C7.28304 2.97064 7.125 3.35218 7.125 3.75V12"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.88086 14.0939C4.09593 15.1834 6.53152 15.75 9.00004 15.75C11.4686 15.75 13.9041 15.1834 16.1192 14.0939C16.2359 14.028 16.3328 13.9321 16.3997 13.816C16.4667 13.7 16.5014 13.5681 16.5 13.4341V12.75C16.5 12.5511 16.421 12.3603 16.2804 12.2197C16.1397 12.079 15.9489 12 15.75 12H2.25004C2.05112 12 1.86036 12.079 1.71971 12.2197C1.57905 12.3603 1.50004 12.5511 1.50004 12.75V13.4341C1.49872 13.5681 1.53335 13.7 1.60034 13.816C1.66732 13.9321 1.76419 14.028 1.88086 14.0939Z"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 12V10.2306C15.7494 8.76799 15.2736 7.3452 14.3944 6.17641C13.5152 5.00762 12.2801 4.15608 10.875 3.75"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.125 3.75C5.71993 4.15608 4.48481 5.00762 3.60558 6.17641C2.72636 7.3452 2.25062 8.76799 2.25 10.2306V12"
        stroke="#323232"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default WorkerHatIcon;
